module.exports = __webpack_public_path__ + "img/study.e467a5f1.jpg";